import React from 'react';
import Grid from './Grid.js';

function App() {
  return (
    <div>
        <Grid />
    </div>
  );
}

export default App;
